import styled from "styled-components/macro";
import hh from "assets/images/HH.png";

const maxWidthMediaLeftColumn = 850;
const maxWidthMediaRightColumn = 640;

// SHARED //

export const GridWrapper = styled.div<{ gap?: string }>`
  display: grid;
  gap: ${(props) => props.gap || "0px"};

  & li {
    list-style-type: none;
  }
`;

export const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 11px;

  @media (max-width: ${maxWidthMediaLeftColumn}px) {
    flex-direction: column;
    justify-content: flex-start;

    & h2 {
      margin-bottom: 4px;
    }
  }

  @media (max-width: ${maxWidthMediaRightColumn}px) {
    flex-direction: row;
    justify-content: space-between;
  }

  @media (max-width: 460px) {
    flex-direction: column;
  }
`;

// MAIN COMPONENT //

export const MainWrapper = styled.div`
  position: relative;
  max-width: ${(props) => props.theme.sizes.maxWidthMainWindow};
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: ${(props) => props.theme.sizes.heightHeaderDesktop} auto 47px;
  color: ${(props) => props.theme.colors.text};

  #handle-close {
    position: absolute;
    top: 0.2em;
    right: 0.5em;
    cursor: pointer;
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    background: transparent;
    font-size: 1rem;
    font-weight: 700;
    color: ${(props) => props.theme.colors.text};
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.2);
    }
  }
  
  @media (max-width: ${maxWidthMediaRightColumn}px) {
    flex-direction: column;
  }
  @media (max-width: 768px) {
    margin: 0px auto 47px;
  }
`;

export const MainBody = styled.div`
  display: flex;
  margin: 1rem;

  @media (max-width: ${maxWidthMediaRightColumn}px) {
    flex-direction: column;
  }
`;

// ROOM NAVIGATION COMPONENT //

export const RoomNavigationSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 1rem;
  font-size: ${(props) => props.theme.font.sizeTitle};
  font-weight: ${(props) => props.theme.font.weightBold};
  align-items: center;

  & .my-rooms {
    color: ${(props) => props.theme.colors.textDimmed};
    margin-right: 16px;
    cursor: pointer;
  }
  
  & svg {
    display: none
  }
  @media (max-width: 450px) {
    margin-top: 24px;
    & .my-rooms {
      font-size: 18px;
    }
    & svg {
      transform: rotateY(180deg);
      margin-right: 4px;
      order: -1;
      display: block
    }
  }
`;

// LEFT COLUMN //

export const LeftColumnAbout = styled.div`
  display: flex;
  flex: 1;
`;

export const DetailsSection = styled.div`
  min-width: 288px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 4px;
  background: ${(props) => props.theme.colors.place};
  padding: 24px 46px 24px 24px;
`;

// ROOM DETAILS COMPONENT //

export const RoomDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RoomDetailsDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 20.8px;
  height: 100%;
  word-break: break-word;
`;

export const TypeOfRoom = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px 0;
`;

export const Location = styled.div`
  display: flex;

  & div {
    flex: 1;
  }

  @media (max-width: ${maxWidthMediaLeftColumn}px) {
    flex-direction: column;
  }
  @media (max-width: ${maxWidthMediaRightColumn}px) {
    flex-direction: row;
  }
  @media (max-width: 460px) {
    flex-direction: column;
  }
`;

// ABOUT THE ROOM COMPONENT //

export const AboutTheRoomSection = styled(RoomDetailsSection)`
  margin: 24px 0;
`;
export const AboutTheRoomRow = styled.div`
  display: flex;
  width: 100%;
  & div {
    flex: 1;
    margin-bottom: 16px;
  }
  @media (max-width: ${maxWidthMediaLeftColumn}px) {
    flex-direction: column;
  }
  @media (max-width: ${maxWidthMediaRightColumn}px) {
    flex-direction: row;
  }
  @media (max-width: 460px) {
    flex-direction: column;
  }
`;

// AVAILABILITY AND PRICES COMPONENT //

export const AvailabilityAndPricesSection = styled(RoomDetailsSection)`
  margin-top: -16px;
`;

export const AboutTheRoomDetails = styled.div`
  display: flex;
  flex-direction: column;

  & div {
    @media (max-width: ${maxWidthMediaLeftColumn}px) {
      flex-direction: column;
    }
  }

  & div {
    @media (max-width: ${maxWidthMediaRightColumn}px) {
      flex-direction: row;
    }
  }

  & div {
    @media (max-width: 460px) {
      flex-direction: column;
    }
  }
`;

// RIGHT COLUMN //

export const RightColumnAbout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 16px;
  @media (max-width: ${maxWidthMediaRightColumn}px) {
    margin: 24px 0;
  }
`;

// HOST DETAILS COMPONENT //

export const HostDetailsWrapper = styled.div`
  min-width: 288px;
  display: flex;
  flex-direction: column;
  border: 1px solid #dcd6ce;
  border-radius: 4px;
  background: #fff;
  padding: 24px;

  &:nth-child(2) {
    margin: 24px 0;
  }
`;

export const HostDetailsInfoSection = styled.div`
  display: flex;
  justify-content: space-between;

  & img {
    height: 120px;
    width: 120px;
    border-radius: 50%;
  }
`;

export const HostDetailsAbout = styled.div`
  display: flex;
  flex-direction: column;

  & div {
    margin-top: 8px;
  }
`;

// SOCIAL PREFERENCES COMPONENT //

export const SocialPreferensecRange = styled.div`
  margin-top: 24px;
`;

// MAP //

const markerSize = 100;

export const MapWrapper = styled.div`
  height: 423px;
  // width: 100%;
  margin: 1rem;
`;

export const MapSelectedPlace = styled.div`
  height: ${markerSize - 20}px;
  width: ${markerSize}px;

  position: absolute;
  top: -${markerSize - 20}px;
  left: -${markerSize / 2 - 10}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: center / contain no-repeat url(${hh}) #eeeeee97;
  border-radius: 20px;
  & div {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 25%;
    top: 50%;
  }
`;
